export default __webpack_public_path__ + "static/media/mint-phase.c1b0f6ff.png";